import { themeGet } from '@styled-system/theme-get'
import { Box, Text } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'

const Cell = styled(Box)`
  display: inline-block;
  vertical-align: top;
  line-height: 1.8;
  text-align: center;
  width: 100%;
  height: 50px;
  border-radius: ${(props) => (props.selected ? themeGet('borderRadii.lg') : themeGet('borderRadii.md'))};
  &:hover {
    background: ${(props) => !props.selected && !props.grouped && 'transparent'};
  }
`

const Price = styled(Text)`
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
`

const getColor = (props) => {
  if (!props.isValid || !props.showColor) {
    return null
  } else if (props.isSelected) {
    return 'primary.base'
  } else if (props.isGrouped) {
    return 'primary.dark'
  } else if (!props.customDayProps) {
    // mark day with yellow if no data for specific day
    return 'caution.light'
  } else if (props.customDayProps.price < props.lowestPrice + 50) {
    return 'pricePrimary.light'
  } else if (props.customDayProps.price < props.lowestPrice + 100) {
    return 'caution.light'
  }
  return 'warning.light'
}

const currency = '$'

const CustomDayWithColorCode = (props) => {
  const { day, customDayProps, isValid, isSelected, isGrouped, use2024DesignSeti } = props
  const displayedPrice = isValid && customDayProps ? `${currency}${customDayProps.price}` : ''

  const color = getColor(props)

  return (
    <Cell data-testid={color} color={color} grouped={isGrouped} selected={isSelected}>
      <Text fontWeight={use2024DesignSeti ? 'normal' : 'bold'} fontSize={2}>
        {day}
      </Text>
      {displayedPrice && (
        <Price color={isSelected || isGrouped ? 'text.lightest' : 'text.base'}>{displayedPrice}</Price>
      )}
    </Cell>
  )
}

export default CustomDayWithColorCode
